import { TreeNode } from '../components/UI/Tree/Tree'
import { Thread } from '../models/forum/new-forum.model'
import { FolderType, ResourceProps, ResourceType } from '../models/new-resource'

export const getThreadTree = (threadList: Thread[]): ResourceProps[] => {
    return threadList.map((thread) => ({
        // key: thread._id,
        // data: thread.title,
        title: thread.title,
        _id: thread._id,
        folderType: FolderType.document,
        // label: thread.title,
        // icon: 'cu cu-folder-bullets',
        // selectable: true,
    }))
}
